export class CompanyConstant {
    static COM_ID_MEDIUSKR: string = 'MEDIUSKR';
    static COM_ID_MEDIUS: string = 'MEDIUSUS';
    // static COM_ID_MEDIUSUS: string = 'MEDIUSUS';
  }